import React, { useCallback, useEffect, useState } from "react";
import { Edit, Delete } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  handleDeleteProductRequest,
  handleGetCatalogProductsRequest,
} from "store/modules/Catalog/thunk.store";
import { CoverageCatalogProductsResponse } from "store/modules/Catalog/types.store";
import Glp from "assets/supergasbras/images/glp.png";
import { useTranslation } from "react-i18next";
import * as Styled from "./styles";
import UpdateProductModal from "./components/UpdateProductModal";

interface Data {
  Imagem: any;
  Nome: string;
  Descrição: string;
  Categoria: string;
  Marca: string;
  action: any;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}
export const useProducts = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const [products, setProducts] =
    useState<CoverageCatalogProductsResponse | null>();
  const [edit, setEdit] = useState<boolean>(false);
  const [selected, setSelected] = useState(null);

  const { catalogProducts } = useAppSelector((state) => state.catalog);

  const HandleCatalogProducts = useCallback(() => {
    setProducts(catalogProducts);
  }, [catalogProducts]);

  useEffect(() => {
    if (!catalogProducts?.data) {
      dispatch(handleGetCatalogProductsRequest());
    }
    if (catalogProducts?.data) {
      HandleCatalogProducts();
    }
  }, [dispatch, HandleCatalogProducts, catalogProducts]);

  const handleDeleteProduct = useCallback(
    async (productId: string) => {
      await dispatch(handleDeleteProductRequest({ productId }));
    },
    [dispatch],
  );

  const headCells: readonly HeadCell[] = [
    {
      id: "Imagem",
      numeric: false,
      disablePadding: true,
      label: t("image"),
    },
    {
      id: "Nome",
      numeric: true,
      disablePadding: false,
      label: t("name"),
    },
    {
      id: "Descrição",
      numeric: true,
      disablePadding: false,
      label: t("description"),
    },
    {
      id: "Categoria",
      numeric: true,
      disablePadding: false,
      label: t("category"),
    },
    {
      id: "Marca",
      numeric: true,
      disablePadding: false,
      label: t("brand"),
    },
    {
      id: "action",
      numeric: true,
      disablePadding: false,
      label: "",
    },
  ];

  function createData(
    Imagem: any,
    Nome: string,
    Descrição: string,
    Categoria: string,
    Marca: string,
    action: any,
  ): Data {
    return {
      Imagem,
      Nome,
      Descrição,
      Categoria,
      Marca,
      action,
    };
  }

  const ActionEditProductModal = () => {
    return (
      <UpdateProductModal
        isOpen={edit}
        update={selected}
        title={t("product")}
        onClose={() => setEdit(false)}
      />
    );
  };

  const ActionButton = (data: any, isEdit: any) => {
    if (isEdit?.length) {
      return (
        <div style={{ width: "200px", display: "flex" }}>
          <Styled.ActionContainer
            onClick={() => handleDeleteProduct(data.data.id)}
            color="primary"
            variant="text"
            endIcon={<Delete />}
          >
            {t("delete").toUpperCase()}
          </Styled.ActionContainer>
          <Styled.ActionContainer
            onClick={() => {
              setSelected(data);
              setEdit(true);
            }}
            color="secondary"
            variant="text"
            endIcon={<Edit />}
          >
            {t("edit").toUpperCase()}
          </Styled.ActionContainer>
        </div>
      );
    }
    return <div style={{ width: "200px", display: "flex" }}> </div>;
  };

  const rows =
    products?.data.map((data) => {
      return createData(
        <img
          src={data?.imageUrl || Glp}
          alt="glp"
          loading="lazy"
          style={{ width: "50px", height: "50px" }}
        />,
        data?.name ?? "",
        data?.description ?? "",
        data?.category?.name,
        data?.brand?.name,
        <ActionButton data={data} />,
      );
    }) || [];

  return { headCells, rows, ActionEditProductModal };
};
